<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

//git联通测试
export default {
    name: 'App',
}
</script>
